import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import './index.css';

import { Table } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '@material-ui/lab/Pagination';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import Spinner from '../../../../../components/Spinner'
import { ptPlusUsersList, ptPlusParentUsersList, tableActonsApiFunc, userListDeleteFunc, getDraftedRecordApi } from '../../../../../../redux/actions/adminPtPlus';
import { SearchWrapper, DateWrapper } from '../../DashBoard/dashBoardStyled'
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'
import { FlatFeeModalWrapper } from './PTPlusStyled'
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import CsvDownloader from 'react-csv-downloader';
import { AiOutlineSearch, AiOutlineArrowDown, AiOutlineArrowUp, AiOutlineVerticalAlignMiddle } from "react-icons/ai";
import AddPlusIcon from "web/assets/svg/PtPlusUserAddPlusIcon";
import ViewIcon from "web/assets/svg/PtPlusUserViewIcon";
import DeleteIcon from "web/assets/svg/PtPlusUserDeleteIcon";
import EllipsisIcon from "web/assets/svg/PtPlusUserEllipsisIcon";
import ApproveIcon from "web/assets/svg/PtPlusUserApproveIcon";
import ExportIcon from "web/assets/svg/PtPlusUserExportIcon";
import EditIcon from "web/assets/svg/PtPlusUserEditIcon";
import DeclineIcon from "web/assets/svg/PtPlusUserDeclineIcon";
import CloseIcon from "web/assets/images/CloseIcon.png";

import ExportModal from './ExportModal'
import InviteNewCustomerModal from './InviteNewCustomerModal';


import AlertModal from 'web/components/AlertModal';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Breadcrumb from "web/components/Breadcrumb";
import { storeAdminDetails, logoutAdmin } from 'redux/actions/admin';
import { ptPlusUpdateParentUserAPI } from 'redux/actions/adminPtPlus/index';
import AdminCreateCustomer from './AdminCreateCustomer';
import ViewAndEditUserInfo from './ViewAndEditUserInfo';
import ParentUserForm from './ParentUserForm.js';

const INIT_PARENT_USER_PAGE_DETAILS = {
  page: 1,
  pageCount: 1,
}


function PTPlusUserManagement({ scrollTop }) {
  const dispatch = useDispatch();
  let history = useHistory()
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const [draftedDataList, setDraftedDataList] = useState()
  const [dataList, setDataList] = useState([])
  const [finalData, setFinalData] = useState()
  const [tableSearch, setTableSearch] = useState('')
  const [filterDataList, setFilterDataList] = useState([]);
  const [csvData, setCsvData] = useState([])
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState('');
  const [currentTab, setCurrentTab] = useState('normal-accounts'); //normal-accounts/parent-accounts

  const [actionValuesState, setActionValuesState] = useState()
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalContent, setConfirmationModalContent] = useState('');
  const [exportModal, setExportModal] = useState(false)
  const [inviteCustomerModal, setInviteCustomerModal] = useState(false)

  // userLists/adminCreateCustomer/viewAndEditCustomer/createParentAccount
  const [selectedPage, setSelectedPage] = useState('userLists')
  const [actionPopUpOpenIndex, setActionPopUpOpenIndex] = useState('null')

  const token = localStorage.getItem("token")

  let headerArr = [
    { title: 'Company Name', sort: true, sortColumn: 'companyName' },
    { title: 'Contact Name', sort: true, sortColumn: 'userName' },
    { title: 'Contact Email', sort: true, sortColumn: 'emailId' },
    { title: 'Account Manager', sort: true, sortColumn: 'accountManager' },
    { title: 'Status', sort: true, sortColumn: 'status' },
    { title: 'Registered Date', sort: true, sortColumn: 'dateAdded' },
    { title: 'Notes', },
    { title: 'Action', },
  ];

  let csvHeaders = [
    { displayName: 'Company Name', id: 'Company', order: 1 },
    { displayName: 'Contact Name', id: 'UserName', order: 2 },
    { displayName: 'Contact Email', id: 'Email', order: 3 },
    { displayName: 'City', id: 'locationCity', order: 4 },
    { displayName: 'State', id: 'locationState', order: 5 },
    { displayName: 'Zip', id: 'locationZip', order: 6 },
    { displayName: 'Billing Email', id: 'BillingContactEmail', order: 7 },
    { displayName: 'Billing Other Email', id: 'OtherContactEmail', order: 8 },
    { displayName: 'Billing City', id: 'billingCity', order: 9 },
    { displayName: 'Billing State', id: 'billingState', order: 10 },
    { displayName: 'Billing Zip', id: 'billingZip', order: 11 },
    { displayName: 'Account Manager', id: 'AccManager', order: 12 },
    { displayName: 'Status', id: 'Status', order: 13 },
    { displayName: 'Registered Date', id: 'DateAdded', order: 14 },
    { displayName: 'Notes', id: 'Note', order: 15 },
  ]

  const checkStyle = {
    appearance: 'auto',
    marginRight: '5px',
    paddingTop: '24px',
    height: '15px',
    width: '15px',
    position: 'relative',
    top: '2px',
  }

  let toDate = new Date();
  let fromDate = new Date("January 1, 2023 03:24:00");
  fromDate.setDate(fromDate.getDate());
  // fromDate.setDate(fromDate.getDate() - 30);
  const [userStateValues, setUserStateValues] = useState({
    fromDate: fromDate.toISOString().substring(0, 10),
    toDate: toDate.toISOString().substring(0, 10),
    sortColumn: 'dateAdded',
    sortState: 'descend'
  })

  const setSortState = (columnVal, sortVal) => {
    let nextType = ''
    let nextColumn = columnVal

    if (sortVal === 'normal') nextType = 'ascend'
    else if (sortVal === 'ascend') nextType = 'descend'
    else if (sortVal === 'descend') nextType = 'normal'

    if (nextColumn !== 'dateAdded') {
      if (nextType === 'normal') {
        nextColumn = 'dateAdded'
        nextType = 'descend'
      } else nextColumn = columnVal
    }


    if (currentTab === 'normal-accounts') {
      setUserStateValues(prevState => ({
        ...prevState,
        sortColumn: nextColumn,
        sortState: nextType
      }))
      filterDataFunction(tableSearch, dataList, nextColumn, nextType)

    } else if (currentTab === 'parent-accounts') {
      setParentUserSettings(prevState => ({
        ...prevState,
        sortColumn: nextColumn,
        sortState: nextType
      }));
      filterDataFunction(
        tableSearch,
        parentUserC,
        nextColumn,
        nextType,
        'parent-user'
      );
    }
  }

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
    fetchUsersList();
  }, []);

  const fetchUsersList = async () => {
    let response = '';
    let data = {
      startDate: (moment(userStateValues.fromDate)).valueOf(),
      endDate: (moment(userStateValues.toDate)).valueOf()
    }
    response = await dispatch(ptPlusUsersList(data, token));
    if (response.success) {
      let adminUserDataList = []
      adminUserDataList = response.data?.customerResponses?.map(data => {
        return {
          ...data,
          userCheckBox: false
        }
      })
      setDataList(adminUserDataList)
      filterDataFunction(tableSearch, adminUserDataList, userStateValues.sortColumn, userStateValues.sortState)
    } else if (response.message === 'Request failed with status code 409') {
      setDataList([])
      setFilterDataList([])
      setFinalData([])
      setCsvData([])
    } else {
      if (response.statusCode === 401) {
        adminLogout()
      } else {
        setAlertModalContent(response.message)
        setAlertModal(!alertModal)
      }
    }
  };
  const adminLogout = () => {
    dispatch(storeAdminDetails([], {}))
    dispatch(logoutAdmin())
    localStorage.removeItem('adminRolesData')
    localStorage.removeItem('adminName')
    localStorage.removeItem('adminEmail')
    localStorage.removeItem('token')
    history.push('./sign-in')
    window.location.reload(false);
  }

  const editDraftedRecord = async (id, type) => {
    let response = '';
    response = await dispatch(getDraftedRecordApi(id, token))
    if (response.success) {
      setDraftedDataList(response.data)
      if (type === "editFlow") setSelectedPage('adminCreateCustomer')
      else if (type === 'viewAndEditFlow') setSelectedPage('viewAndEditCustomer')
    } else {
      if (response.statusCode === 401) {
        adminLogout()
      } else {
        setAlertModalContent(response.message)
        setAlertModal(!alertModal)
      }
    }
  }

  //handle page change in users
  const handleChange = (event, value) => {
    setPage(value);
    let dataListtemp = JSON.parse(JSON.stringify(filterDataList))
    setFinalData(dataListtemp.splice(value * 10 - 10, 10))
  };

  const handleSearchChange = e => {
    e.preventDefault()
    setTableSearch(e.target.value)
    const search = e.target.value
    if (currentTab === 'normal-accounts') {
      filterDataFunction(
        search,
        dataList,
        userStateValues.sortColumn,
        userStateValues.sortState,
        'normal-user'
      )
    }
    if (currentTab === 'parent-accounts') {
      filterDataFunction(
        search,
        parentUserC,
        parentUserSettings.sortColumn,
        parentUserSettings.sortState,
        'parent-user',
      )
    }
  }

  const searchResultData = (dataList, search) => {
    let dataListtemp = dataList.filter(value => {
      return (
        value.companyName?.toString().toLowerCase().includes(search.toLowerCase()) ||
        value.customerName?.toString().toLowerCase().includes(search.toLowerCase()) ||
        value.emailAddress?.toString().toLowerCase().includes(search.toLowerCase()) ||
        value.status?.toString().toLowerCase().includes(search.toLowerCase()) ||
        value.locationName?.toString().toLowerCase().includes(search.toLowerCase())
      )
    });
    return dataListtemp
  }

  const sortResultFunction = (data, sortColumn, sortState) => {
    let dataListtemp = data

    if (sortColumn === 'companyName') {
      if (sortState === 'ascend') {
        dataListtemp = dataListtemp.sort((a, b) => {
          if (a.companyName?.toLowerCase() < b.companyName?.toLowerCase()) return -1;
          if (a.companyName?.toLowerCase() > b.companyName?.toLowerCase()) return 1;
          return 0;
        })
      } else if (sortState === 'descend') {
        dataListtemp = dataListtemp.sort((a, b) => {
          if (a.companyName?.toLowerCase() > b.companyName?.toLowerCase()) return -1;
          if (a.companyName?.toLowerCase(), b.companyName?.toLowerCase()) return 1;
          return 0;
        })
      }
    } else if (sortColumn === 'userName') {
      if (sortState === 'ascend') {
        dataListtemp = dataListtemp.sort((a, b) => {
          if (a.customerName?.toLowerCase() < b.customerName?.toLowerCase()) return -1;
          if (a.customerName?.toLowerCase() > b.customerName?.toLowerCase()) return 1;
          return 0;
        })
      } else if (sortState === 'descend') {
        dataListtemp = dataListtemp.sort((a, b) => {
          if (a.customerName?.toLowerCase() > b.customerName?.toLowerCase()) return -1;
          if (a.customerName?.toLowerCase(), b.customerName?.toLowerCase()) return 1;
          return 0;
        })
      }
    } else if (sortColumn === 'emailId') {
      if (sortState === 'ascend') {
        dataListtemp = dataListtemp.sort((a, b) => {
          if (a.emailAddress?.toLowerCase() < b.emailAddress?.toLowerCase()) return -1;
          if (a.emailAddress?.toLowerCase() > b.emailAddress?.toLowerCase()) return 1;
          return 0;
        })
      } else if (sortState === 'descend') {
        dataListtemp = dataListtemp.sort((a, b) => {
          if (a.emailAddress?.toLowerCase() > b.emailAddress?.toLowerCase()) return -1;
          if (a.emailAddress?.toLowerCase(), b.emailAddress?.toLowerCase()) return 1;
          return 0;
        })
      }
    } else if (sortColumn === 'accountManager') {
      if (sortState === 'ascend') {
        dataListtemp = dataListtemp.sort((a, b) => {
          if (a.customerName?.toLowerCase() < b.customerName?.toLowerCase()) return -1;
          if (a.customerName?.toLowerCase() > b.customerName?.toLowerCase()) return 1;
          return 0;
        })
      } else if (sortState === 'descend') {
        dataListtemp = dataListtemp.sort((a, b) => {
          if (a.customerName?.toLowerCase() > b.customerName?.toLowerCase()) return -1;
          if (a.customerName?.toLowerCase(), b.customerName?.toLowerCase()) return 1;
          return 0;
        })
      }
    } else if (sortColumn === 'status') {
      if (sortState === 'ascend') {
        dataListtemp = dataListtemp.sort((a, b) => {
          if (a.status?.toLowerCase() < b.status?.toLowerCase()) return -1;
          if (a.status?.toLowerCase() > b.status?.toLowerCase()) return 1;
          return 0;
        })
      } else if (sortState === 'descend') {
        dataListtemp = dataListtemp.sort((a, b) => {
          if (a.status?.toLowerCase() > b.status?.toLowerCase()) return -1;
          if (a.status?.toLowerCase(), b.status?.toLowerCase()) return 1;
          return 0;
        })
      }
    } else if (sortColumn === 'dateAdded') {
      if (sortState === 'ascend') {
        dataListtemp = dataListtemp.sort((a, b) => {
          return a.createdAt - b.createdAt;
        })
      } else if (sortState === 'descend') {
        dataListtemp = dataListtemp.sort((a, b) => {
          return b.createdAt - a.createdAt;
        })
      }
    } else if (sortColumn === 'locationName') {
      if (sortState === 'ascend') {
        dataListtemp = dataListtemp.sort((a, b) => {
          console.log('##a', a);
          if (a.locationName?.toLowerCase() < b.locationName?.toLowerCase()) return -1;
          if (a.locationName?.toLowerCase() > b.locationName?.toLowerCase()) return 1;
          return 0;
        })
      } else if (sortState === 'descend') {
        dataListtemp = dataListtemp.sort((a, b) => {
          if (a.locationName?.toLowerCase() > b.locationName?.toLowerCase()) return -1;
          if (a.locationName?.toLowerCase(), b.locationName?.toLowerCase()) return 1;
          return 0;
        })
      }
    }
    return dataListtemp
  }

  const filterDataFunction = (searchText,
    wholeData,
    sortColumnValue,
    sortStateValue,
    dataType = 'normal-user' // normal-user/parent-user
  ) => {
    let filterResult = searchResultData(wholeData, searchText)
    filterResult = sortResultFunction(filterResult, sortColumnValue, sortStateValue)

    let tempSearchData = JSON.parse(JSON.stringify(filterResult))

    if (dataType === 'normal-user') {
      setPage(1);

      if (filterResult.length % 10 === 0) {
        setPageCount(filterResult.length / 10)
      } else {
        setPageCount(Math.trunc(filterResult.length / 10) + 1)
      }

      setFilterDataList(tempSearchData)
      setFinalData(filterResult.splice(0, 10))

      //set csv data
      csvDataSettingFunc(tempSearchData)
    } else if (dataType === 'parent-user') {
      setParentUserPageDetails({
        // ...parentUserPageDetails,
        page: 1,
        pageCount: Math.ceil(filterResult.length / 10)
      });

      setFilteredParentUserC(filterResult)
    }
  }

  const tableActionConfirmation = (action, id) => {
    setActionValuesState({ actionVal: action, idVal: id })
    let modalMessageText = ''
    if (action === 'APPROVED') modalMessageText = 'Are you sure you want to approve the user?'
    else if (action === 'DECLINED') modalMessageText = 'Are you sure you want to decline the request of the user?'
    else if (action === 'deleteOne') modalMessageText = 'Are you sure you want to delete the user?'
    else if (action === 'deleteAll') modalMessageText = 'Are you sure you want to delete all the selected users?'
    setConfirmationModalContent(modalMessageText)
    setConfirmationModal(!confirmationModal)
  }

  const handleCheck = (event, index, items) => {
    let tempData = JSON.parse(JSON.stringify(dataList))
    let tempFilterData = JSON.parse(JSON.stringify(filterDataList))
    tempFilterData[(page * 10 - 10) + index].userCheckBox = !tempFilterData[(page * 10 - 10) + index].userCheckBox
    tempFilterData = tempFilterData.map(data => ({ ...data }))
    let indexVal = tempData.findIndex(val => val.id === tempFilterData[(page * 10 - 10) + index].id);
    tempData[indexVal].userCheckBox = !tempData[indexVal].userCheckBox
    tempData = tempData.map(data => ({ ...data }))
    let tempDataList = JSON.parse(JSON.stringify(tempData))
    let tempDataFilterList = JSON.parse(JSON.stringify(tempFilterData))
    setDataList(tempDataList)
    setFilterDataList(tempDataFilterList)
    setFinalData(tempFilterData.splice(page * 10 - 10, 10))
  }

  const tableActionFunc = async () => {
    setConfirmationModal(false)
    if (actionValuesState.actionVal === 'deleteOne' || actionValuesState.actionVal === 'deleteAll') {
      deleteFuncCall(actionValuesState.actionVal, actionValuesState.idVal)
    } else {
      let response = '';
      response = await dispatch(tableActonsApiFunc(actionValuesState.actionVal, actionValuesState.idVal, token))
      if (response.success) {
        let resMsg = 'Updated Successfully'
        if (actionValuesState.actionVal === 'APPROVED') resMsg = 'User has been approved successfully.'
        else if (actionValuesState.actionVal === 'DECLINED') resMsg = 'User has been declined successfully.'
        setAlertModalContent(resMsg)
        setAlertModal(!alertModal)
        fetchUsersList()
      } else {
        if (response.statusCode === 401) {
          adminLogout()
        } else {
          const errorMessage = response?.data?.error?.message
            || response?.data?.message
            || response?.message
            || 'Something went wrong, please try again in some time.'
          setAlertModalContent(errorMessage);
          setAlertModal(!alertModal)
        }
      }
    }
  }

  const deleteFuncCall = async (mode, id) => {
    setConfirmationModal(false)
    let deleteIdList = []
    if (mode === 'deleteAll') deleteIdList = dataList.filter(val => val.userCheckBox).map(val => val.id)
    else deleteIdList = [id]
    let response = '';
    let data = {
      customerIds: deleteIdList,
    }
    response = await dispatch(userListDeleteFunc(data, token))
    if (response.success) {
      let resMsg = 'User has been deleted successfully.'
      if (mode === 'deleteAll') resMsg = 'Users have been deleted successfully.'
      setAlertModalContent(resMsg)
      setAlertModal(!alertModal)
      fetchUsersList()
    } else {
      if (response.statusCode === 401) {
        adminLogout()
      } else {
        setAlertModalContent(response.message)
        setAlertModal(!alertModal)
      }
    }
  }

  const csvDataSettingFunc = (list, type) => {
    let tempData = JSON.parse(JSON.stringify(list))
    let tempCSVDate = tempData?.map(items => {
      return ({
        Company: items.companyName?.replaceAll(",", " "),
        UserName: items.customerName?.replaceAll(",", " "),
        Email: items.emailAddress,
        locationCity: items.locationAddress?.city?.replaceAll(",", " "),
        locationState: stateConvert(items.locationAddress?.state?.trim()) || items.locationAddress?.state?.trim(),
        locationZip: items.locationAddress?.zipCode,
        billingCity: items.billingAddress?.city?.replaceAll(",", " "),
        billingState: stateConvert(items.billingAddress?.state?.trim()) || items.billingAddress?.state?.trim(),
        billingZip: items.billingAddress?.zipCode,
        BillingContactEmail: items.billToEmailAddress,
        OtherContactEmail: items.otherContactEmail,
        AccManager: items.accountManager,
        Status: items.status,
        DateAdded: moment(items.createdAt * 1000).format("MM-DD-YYYY"),
        Note: items.notes ? items.notes?.replaceAll(",", " ").replaceAll("\n", " ") || '' : 'NA',
      })
    })
    setCsvData(tempCSVDate)
    if (type === 'singleRow') return tempCSVDate
  }
  const buttonStyleBlue = {
    background: '#005586',
    color: 'white',
    border: 0,
    borderRadius: '5px',
    padding: '5px 15px',
    margin: '5px'
  }
  const sortIconStyle = {
    height: '22px',
    width: '28px',
    color: '#61b01f'
  }
  /*---------------------New Code-------------------------*/
  const [parentUserModal, setParentUserModal] = useState(false);
  const [parentUserFormData, setParentUserFormData] = useState({});
  const [parentUserFormType, setParentUserFormType] = useState('create'); //create/edit

  const [parentUserPageDetails, setParentUserPageDetails]
    = useState(INIT_PARENT_USER_PAGE_DETAILS);
  const [parentUserSettings, setParentUserSettings] = useState({
    // sortColumn: 'locationName',
    // sortState: 'descend'
    sortColumn: null,
    sortState: null,
  });
  const [parentUserC, setParentUserC] = useState([]);
  const [filteredParentUserC, setFilteredParentUserC] = useState([]);
  const columns = [
    // { title: 'Location Name', sort: true, sortColumn: 'locationName' },
    // { title: 'Contact Email', sort: true, sortColumn: 'emailId' },
    { title: 'Location Name', sort: true, sortColumn: 'locationName' },
    { title: 'Contact Email', sort: true, sortColumn: 'emailId' },
    { title: 'Assigned Locations' },
    { title: 'Contact Number' },
    { title: 'Address' },
    { title: 'City' },
    { title: 'State' },
    // { title: 'Status', sort: true, sortColumn: 'status' },
    // { title: 'Notes', },
    { title: 'Action', className: 'parent-account-actions-header' },
    { title: '', }, // Empty heading to add styling
  ];
  const fetchParentUsersList = async () => {
    let response = '';
    let data = {};
    response = await dispatch(ptPlusParentUsersList(data, token));
    // console.log('##response', response);
    if (response.success) {
      let customers = response.data.customers;
      setParentUserC(customers);
      // setFilteredParentUserC(customers);
      // setParentUserPageDetails(INIT_PARENT_USER_PAGE_DETAILS);
      filterDataFunction(
        tableSearch,
        customers,
        parentUserSettings.sortColumn,
        parentUserSettings.sortState,
        'parent-user'
      );
      setFilteredParentUserC(oldFinalList => oldFinalList.splice(1 * 10 - 10, 10))
    } else if (response.statusCode === 409) {
      setParentUserC([]);
      setFilteredParentUserC([]);
    } else {
      if (response.statusCode === 401) {
        adminLogout()
      } else {
        setAlertModalContent(response.message)
        setAlertModal(!alertModal)
      }
    }
  };
  const onParentUserPageClick = (event, value) => {
    filterDataFunction(
      tableSearch,
      parentUserC,
      parentUserSettings.sortColumn,
      parentUserSettings.sortState,
      'parent-user'
    );
    // Line should be below filterDataFunction call to ensure parentUserPageDetails
    // are not overridden
    setParentUserPageDetails({ ...parentUserPageDetails, page: value });

    setFilteredParentUserC(oldFinalList => oldFinalList.splice(value * 10 - 10, 10))
  }
  const onParentUserActiveToggleClickConfirmation = (parentUser) => {
    setActionValuesState({ type: 'toggleUserStatus', user: parentUser })
    setConfirmationModalContent(parentUser.active ? 'Are you sure you want to inactivate the user?' : 'Are you sure you want to activate the user?')
    setConfirmationModal(true)
  }
  const onParentUserActiveToggleClick = async (parentUser) => {
    setConfirmationModal(false)
    let requestData = {
      id: parentUser.id,
      active: !parentUser.active,
    };

    const token = localStorage.getItem('token');
    let response = await dispatch(ptPlusUpdateParentUserAPI(requestData, token))
    if (response.success) {
      fetchParentUsersList();
      setAlertModalContent('Parent customer updated successfully.')
      setAlertModal(true)
    } else {
      if (response.statusCode === 401) {
        adminLogout()
      } else {
        const errorMessage = response?.data?.error?.message
          || response?.data?.message
          || response?.message
          || 'Something went wrong, please try again in some time.'
        setAlertModalContent(errorMessage)
        setAlertModal(!alertModal)
      }
    }
    setActionValuesState()
  }

  useEffect(() => {
    fetchParentUsersList();
  }, []);

  return <>
    {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('PT_PLUS')))
      ? <div>
        {loaderVisible && <Spinner />}
        {selectedPage === 'userLists' && <div className='user-list'
          onClick={() => actionPopUpOpenIndex !== 'null' && setActionPopUpOpenIndex('null')}
        >
          <div className='first-row'>
            {/*Below breadcrumb is ideally not required. It is kept for maintaining the layout*/}
            <Breadcrumb
              breadcrumbArr={[]}
              selected=''
              title=""
            />
          </div>
          <TableWrapper>
            <Heading>
              <h3>ACCOUNT MANAGEMENT</h3>
              <div className='d-flex flex-wrap flex-sm-nowrap'>
                <SearchWrapper>
                  <input
                    type="text"
                    placeholder='Search'
                    value={tableSearch}
                    onChange={handleSearchChange}
                  />
                  <AiOutlineSearch />
                </SearchWrapper>
                <div className='vertical-line'></div>
                {currentTab === 'normal-accounts' && <button
                  className='button-style-green'
                  onClick={() => {
                    let checkedData = filterDataList.filter(val => val.userCheckBox)
                    if (checkedData && checkedData.length > 0) csvDataSettingFunc(checkedData)
                    else csvDataSettingFunc(filterDataList)
                    setExportModal(true)
                  }}
                >
                  Export
                </button>}
                {currentTab === 'normal-accounts' && <button
                  className={dataList.filter(val => val.userCheckBox).length < 1 ? 'button-style-green disabled-button' : 'button-style-green'}
                  disabled={dataList.filter(val => val.userCheckBox).length < 1}
                  onClick={() => tableActionConfirmation('deleteAll')}
                >
                  Delete
                </button>}
              </div>
            </Heading>
            <div className='table-sub-row'>
              <Tabs
                value={currentTab}
                setValue={setCurrentTab}
                options={[
                  {
                    id: 'normal-accounts',
                    name: 'Users',
                  },
                  {
                    id: 'parent-accounts',
                    name: 'Parent Users',
                  }
                ]}
              />

              {currentTab === 'normal-accounts' && <div
                className='customer-action-buttons'
              >
                <button
                  style={buttonStyleBlue}
                  onClick={() => setSelectedPage('adminCreateCustomer')}
                >
                  <AddPlusIcon />Create New Customer
                </button>
                <button
                  style={buttonStyleBlue}
                  onClick={() => setInviteCustomerModal(true)}
                >
                  <AddPlusIcon />Invite New Customer
                </button>
              </div>}
              {currentTab === 'parent-accounts' && <div
                className='customer-action-buttons'
              >
                <button
                  style={buttonStyleBlue}
                  onClick={() => {
                    setParentUserFormType('create');
                    setParentUserModal(true);
                  }}
                >
                  <AddPlusIcon />Create New Parent Customer
                </button>
              </div>}
            </div>
            {currentTab === 'normal-accounts' && <Table responsive>
              <thead>
                <tr>
                  {headerArr.map((items, index) => (
                    <th key={index}>
                      {items.title}
                      {items.sort && (() => {
                        const isDescending = userStateValues.sortColumn === items.sortColumn && userStateValues.sortState === 'descend';
                        const isAscending = userStateValues.sortColumn === items.sortColumn && userStateValues.sortState === 'ascend';

                        if (isDescending) {
                          return <AiOutlineArrowDown onClick={() => setSortState(items.sortColumn, 'descend')} style={sortIconStyle} />;
                        } else if (isAscending) {
                          return <AiOutlineArrowUp onClick={() => setSortState(items.sortColumn, 'ascend')} style={sortIconStyle} />;
                        } else {
                          return <AiOutlineVerticalAlignMiddle onClick={() => setSortState(items.sortColumn, 'normal')} style={sortIconStyle} />;
                        }
                      })()}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {
                  finalData && finalData.map((items, index) => (
                    <tr key={index} className='user-list-table-styles'>
                      <td>
                        <input style={checkStyle} type="checkbox" checked={items.userCheckBox} onChange={(event) => handleCheck(event, index, items)} />
                        {items.companyName}
                      </td>
                      <td title={items.customerName}>
                        {items.customerName?.substring(0, 15)}
                        {items.customerName?.length > 15 && <span>...</span>}
                      </td>
                      <td>{items.emailAddress}</td>
                      <td>{items.accountManager}</td>
                      <td>{items.status}</td>
                      <td>{moment(items.createdAt * 1000).format('MM/DD/YYYY')}</td>
                      <td title={items.notes} style={{ minWidth: '168px' }}>
                        {items.notes ? items.notes?.substring(0, 20) : 'NA'}
                        {items.notes?.length > 20 && <span>...</span>}
                      </td>
                      <td style={{ width: '137px', display: 'flex', position: 'relative' }}>
                        {items.status === 'DRAFT' ?
                          <div onClick={() => editDraftedRecord(items.id, 'editFlow')}>
                            <EditIcon />
                          </div> :
                          <div onClick={() => editDraftedRecord(items.id, 'viewAndEditFlow')}>
                            <ViewIcon />
                          </div>}
                        <div onClick={() => tableActionConfirmation('deleteOne', items.id)}>
                          <DeleteIcon />
                        </div>
                        <div onClick={() => setActionPopUpOpenIndex(index)}>
                          <EllipsisIcon />
                        </div>
                        {actionPopUpOpenIndex === index &&
                          <div className={(index > 3) ? 'action-popups-align-top' : 'action-popups'}>
                            <p className='top-arrow'></p>
                            {(items.status === 'PENDING' || items.status === 'COMPLETED') &&
                              <>
                                <div
                                  onClick={() => tableActionConfirmation('APPROVED', items.id)}>
                                  <div style={{ alignItems: 'center' }}><ApproveIcon /></div><span>Approve</span>
                                </div>
                                <div
                                  onClick={() => tableActionConfirmation('DECLINED', items.id)}>
                                  <div style={{ alignItems: 'center' }}><DeclineIcon /></div><span>Decline</span>
                                </div>
                              </>
                            }

                            <CsvDownloader
                              filename="User Details Report"
                              columns={csvHeaders}
                              datas={() => csvDataSettingFunc([items], 'singleRow')}>
                              <div>
                                <div style={{ alignItems: 'center' }}><ExportIcon /></div><span>Export</span>
                              </div>
                            </CsvDownloader>


                          </div>
                        }
                      </td>

                    </tr>
                  ))}
              </tbody>
            </Table>}
            {currentTab === 'parent-accounts' && <Table responsive>
              <thead>
                <tr>
                  {columns.map((items, index) => (
                    <th key={index} className={items.className ? items.className : ''}>
                      {items.title}
                      {items.sort && (() => {
                        const isDescending =
                          parentUserSettings.sortColumn === items.sortColumn
                          && parentUserSettings.sortState === 'descend';
                        const isAscending =
                          parentUserSettings.sortColumn === items.sortColumn
                          && parentUserSettings.sortState === 'ascend';

                        if (isDescending) {
                          return <AiOutlineArrowDown
                            onClick={() => setSortState(items.sortColumn, 'descend')}
                            style={sortIconStyle}
                          />
                        } else if (isAscending) {
                          return <AiOutlineArrowUp
                            onClick={() => setSortState(items.sortColumn, 'ascend')}
                            style={sortIconStyle}
                          />;
                        } else {
                          return <AiOutlineVerticalAlignMiddle
                            onClick={() => setSortState(items.sortColumn, 'normal')}
                            style={sortIconStyle}
                          />;
                        }
                      })()}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredParentUserC && filteredParentUserC.map((parentUser, index) => (
                  <tr key={index} className='user-list-table-styles'>
                    <td className='ellipsis location-name'
                      title={parentUser.locationName}
                    >
                      {parentUser.locationName}
                    </td>
                    <td className='ellipsis email'
                      title={parentUser.emailAddress}
                    >
                      {parentUser.emailAddress}
                    </td>
                    <td>
                      {(parentUser.assignedLocations?.length ?? 0) === 0
                        ? <div className='no-assigned-locations'>
                          No locations assigned
                        </div>
                        : <div className='no-assigned-locations'>
                          {parentUser.assignedLocations.map(l => l.locationName).join(', ')}
                        </div>
                      }
                    </td>
                    <td>
                      {parentUser.contactNumber}
                    </td>
                    <td className='ellipsis address'
                      title={parentUser.street}
                    >
                      {parentUser.street}
                    </td>
                    <td className='city'>
                      {parentUser.city}
                    </td>
                    <td>
                      {stateConvert(parentUser.state) || parentUser.state}
                    </td>
                    <td className='parent-account-actions'>
                      <button className='no-default'
                        onClick={e => {
                          setParentUserFormType('edit');
                          setParentUserModal(true);
                          setParentUserFormData(parentUser);
                        }}
                      >
                        <EditIcon />
                      </button>
                      <FormControlLabel
                        style={{ margin: 0 }}
                        labelPlacement='start'
                        label={parentUser.active
                          ? 'Active'
                          : 'Inactive'
                        }
                        control={<Switch
                          checked={parentUser.active}
                          onClick={e => {
                            onParentUserActiveToggleClickConfirmation(parentUser)
                          }}
                          name='checkedB'
                          color='primary'
                        />}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>}

            {(currentTab === 'normal-accounts' && finalData && finalData.length === 0) && <p
              style={{
                position: 'absolute',
                width: '100%',
                textAlign: 'center',
                marginTop: '40px'
              }}
            >
              No records found
            </p>}
            {(currentTab === 'parent-accounts'
              && filteredParentUserC
              && filteredParentUserC.length === 0
            ) && <p
              style={{
                position: 'absolute',
                width: '100%',
                textAlign: 'center',
                marginTop: '40px'
              }}
            >
                No records found
              </p>}

            {currentTab === 'normal-accounts'
              && dataList.length !== 0
              && <Pagination count={pageCount}
                page={page}
                onChange={handleChange}
              />}
            {currentTab === 'parent-accounts' && parentUserC.length !== 0 && <Pagination
              count={parentUserPageDetails?.pageCount ?? 1}
              page={parentUserPageDetails?.page ?? 1}
              onChange={onParentUserPageClick}
            />}
          </TableWrapper>
        </div>}
        {selectedPage === 'adminCreateCustomer' && <div>
          <AdminCreateCustomer
            draftData={draftedDataList}
            setSelectedPage={val => {
              fetchUsersList()
              setSelectedPage(val)
              setDraftedDataList()
            }}
          />
        </div>}
        {selectedPage === 'viewAndEditCustomer' && <div>
          <ViewAndEditUserInfo
            draftData={draftedDataList}
            scrollTop={scrollTop}
            refreshUserData={(id) => {
              setSelectedPage()
              editDraftedRecord(id, 'viewAndEditFlow')
            }}
            setSelectedPage={val => {
              fetchUsersList()
              setSelectedPage(val)
              setDraftedDataList()
            }}
          />
        </div>}
      </div>
      : <p>You are not authorized to view this page.</p>
    }
    <AlertModal
      isOpen={alertModal}
      toggle={() => setAlertModal(!alertModal)}
      title=''
      content={alertModalContent}
    />
    <Modal isOpen={exportModal} centered={true}>
      <ModalHeader
        toggle={() => setExportModal(false)}
      >
        <h6>Download Report - User Details</h6>
      </ModalHeader>
      <ModalBody>
        <ExportModal
          onEnter={() => setExportModal(false)}
          csvData={csvData} csvHeaders={csvHeaders}
        />
      </ModalBody>
    </Modal>
    <Modal isOpen={confirmationModal} centered={true}>
      <ModalBody>
        {confirmationModalContent}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={() => {
          actionValuesState?.type === 'toggleUserStatus' ?
            onParentUserActiveToggleClick(actionValuesState?.user) :
            tableActionFunc()
        }
        }>
          Yes
        </Button>
        <Button
          color="secondary"
          onClick={() => setConfirmationModal(false)}
        >
          No
        </Button>
      </ModalFooter>
    </Modal>

    <Modal isOpen={inviteCustomerModal} centered={true}>
      <FlatFeeModalWrapper>
        <ModalBody>
          <InviteNewCustomerModal
            toggle={() => setInviteCustomerModal(false)}
          />
        </ModalBody>
      </FlatFeeModalWrapper>
    </Modal>

    <Modal isOpen={parentUserModal} size='lg' centered={true}>
      <div className='modal-header'>
        <h6>
          {parentUserFormType === 'create'
            ? 'Add Parent Customer'
            : 'Edit Parent Customer'
          }
        </h6>
        <img src={CloseIcon} alt='close-icon' onClick={() => setParentUserModal(false)} />
      </div>
      <ModalBody>
        <ParentUserForm
          formType={parentUserFormType}
          formData={parentUserFormData}
          setModal={setParentUserModal}
          fetchCollection={fetchParentUsersList}

          setAlertModal={setAlertModal}
          setAlertModalContent={setAlertModalContent}
        />
      </ModalBody>
    </Modal>
  </>
};

const Tabs = (props) => {
  const onTabClick = (e, id) => {
    e.preventDefault();
    props.setValue(id);
  }

  return <div className='tabs'>
    {props.options.map(tab => <button
      className={`tab${props.value == tab.id ? ' current-tab' : ''}`}
      onClick={e => onTabClick(e, tab.id)}
    >
      {tab.name}
    </button>)}
  </div>
}

export default PTPlusUserManagement;
